// extracted by mini-css-extract-plugin
export default {"Card":"card_Card__up7Vt","Icon":"card_Icon__uv1Gc","Title":"card_Title__na3Ci","Content":"card_Content__q86dC","contentWrapper":"card_contentWrapper__3IW-7"};